export const postAnagrafica = `
mutation postAnagrafica($userId:String!,$tenantId:String!,$aziendaId:Int!,$dataInput:InputDataAnagrafica!){
    postAnagrafica(userId:$userId,tenantId:$tenantId,aziendaId:$aziendaId,dataInput:$dataInput){
        addr2Cap
        addr2Comune
        addr2ComuneId
        addr2Indirizzo
        addr2N
        addr2PaeseId
        addr2Provincia
        addr2ProvinciaId
        addrCap
        addrComune
        addrComuneId
        addrIndirizzo
        addrN
        addrPaeseId
        addrProvincia
        addrProvinciaId
        amlId
        anagraficaId
        apCf
        apNome
        capSociale
        cf
        cognome
        countryCode
        createdBy
        createdOn
        denominazione
        descAttivita
        docN
        docRilDa
        docRilData
        docScad
        docTipoId
        errWs
        errWsNote
        expiryDate
        genereId
        id
        identifiedByUser
        identifiedOn
        importDesc
        isDeleted
        isNotPepMoreThanYear
        isPep
        isPg
        modalitaIdentId
        modifiedBy
        modifiedOn
        nascitaData
        nascitaLuogo
        nome
        office1Id
        office2Id
        orgAmmin
        pepCarica
        pepRuolo
        pIva
        professione
        reaComune
        reaN
        revisionWs
        status
        tenantId
        tipoPatrimonioAltro
        tipoPatrimonioId
        tipoRedditoAltro
        tipoRedditoId
        versionDate
        versionN
        workspaceId
        atecoCode
        attivitaLavDescr
    }
}`;
export const updateAnagrafica = `
mutation updateAnagrafica($id:Int!,$userId:String!,$aziendaId:Int!,$dataInput:InputDataAnagrafica!){
    updateAnagrafica(id:$id,userId:$userId,aziendaId:$aziendaId,dataInput:$dataInput){
        addr2Cap
        addr2Comune
        addr2ComuneId
        addr2Indirizzo
        addr2N
        addr2PaeseId
        addr2Provincia
        addr2ProvinciaId
        addrCap
        addrComune
        addrComuneId
        addrIndirizzo
        addrN
        addrPaeseId
        addrProvincia
        addrProvinciaId
        amlId
        anagraficaId
        apCf
        apNome
        capSociale
        cf
        cognome
        countryCode
        createdBy
        createdOn
        denominazione
        descAttivita
        docN
        docRilDa
        docRilData
        docScad
        docTipoId
        errWs
        errWsNote
        expiryDate
        genereId
        id
        identifiedByUser
        identifiedOn
        importDesc
        isDeleted
        isNotPepMoreThanYear
        isPep
        isPg
        modalitaIdentId
        modifiedBy
        modifiedOn
        nascitaData
        nascitaLuogo
        nome
        office1Id
        office2Id
        orgAmmin
        pepCarica
        pepRuolo
        pIva
        professione
        reaComune
        reaN
        revisionWs
        status
        tenantId
        tipoPatrimonioAltro
        tipoPatrimonioId
        tipoRedditoAltro
        tipoRedditoId
        versionDate
        versionN
        workspaceId
        atecoCode
        attivitaLavDescr
    }
}`;
export const upgradeAnagraficaVersion = `
mutation upgradeVersion($id:Int!,$userId:String!,$aziendaId:Int!,$dataInput:InputDataAnagrafica!){
    upgradeAnagraficaVersion(id:$id,userId:$userId,aziendaId:$aziendaId,dataInput:$dataInput){
        addr2Cap
        addr2Comune
        addr2ComuneId
        addr2Indirizzo
        addr2N
        addr2PaeseId
        addr2Provincia
        addr2ProvinciaId
        addrCap
        addrComune
        addrComuneId
        addrIndirizzo
        addrN
        addrPaeseId
        addrProvincia
        addrProvinciaId
        amlId
        anagraficaId
        apCf
        apNome
        capSociale
        cf
        cognome
        countryCode
        createdBy
        createdOn
        denominazione
        descAttivita
        docN
        docRilDa
        docRilData
        docScad
        docTipoId
        errWs
        errWsNote
        expiryDate
        genereId
        id
        identifiedByUser
        identifiedOn
        importDesc
        isDeleted
        isNotPepMoreThanYear
        isPep
        isPg
        modalitaIdentId
        modifiedBy
        modifiedOn
        nascitaData
        nascitaLuogo
        nome
        office1Id
        office2Id
        orgAmmin
        pepCarica
        pepRuolo
        pIva
        professione
        reaComune
        reaN
        revisionWs
        status
        tenantId
        tipoPatrimonioAltro
        tipoPatrimonioId
        tipoRedditoAltro
        tipoRedditoId
        versionDate
        versionN
        workspaceId
        atecoCode
        attivitaLavDescr
    }
}`;
export const downgradeAnagraficaVersion = `
mutation downgradeVersion($id:Int!,$userId:String!,$aziendaId:Int!){
    downgradeAnagraficaVersion(id:$id,userId:$userId,aziendaId:$aziendaId){
        addr2Cap
        addr2Comune
        addr2ComuneId
        addr2Indirizzo
        addr2N
        addr2PaeseId
        addr2Provincia
        addr2ProvinciaId
        addrCap
        addrComune
        addrComuneId
        addrIndirizzo
        addrN
        addrPaeseId
        addrProvincia
        addrProvinciaId
        amlId
        anagraficaId
        apCf
        apNome
        capSociale
        cf
        cognome
        countryCode
        createdBy
        createdOn
        denominazione
        descAttivita
        docN
        docRilDa
        docRilData
        docScad
        docTipoId
        errWs
        errWsNote
        expiryDate
        genereId
        id
        identifiedByUser
        identifiedOn
        importDesc
        isDeleted
        isNotPepMoreThanYear
        isPep
        isPg
        modalitaIdentId
        modifiedBy
        modifiedOn
        nascitaData
        nascitaLuogo
        nome
        office1Id
        office2Id
        orgAmmin
        pepCarica
        pepRuolo
        pIva
        professione
        reaComune
        reaN
        revisionWs
        status
        tenantId
        tipoPatrimonioAltro
        tipoPatrimonioId
        tipoRedditoAltro
        tipoRedditoId
        versionDate
        versionN
        workspaceId
        atecoCode
        attivitaLavDescr
    }
}`;
export const deleteAnagraficaDuplicates = `
mutation deleteAnagraficaDuplicates($tenantId:String!,$keepId:Int!,$duplicateIds:[Int]!){
    deleteAnagraficaDuplicates(tenantId:$tenantId,keepId:$keepId,duplicateIds:$duplicateIds){
        success
        message
        deletedCount
    }
}`;
export const deleteAnagrafica = `
mutation deleteAnagrafica($anagraficaId: Int!, $tenantId: String!) {
    deleteAnagrafica(id: $anagraficaId, tenantId: $tenantId) {
        message
        deletedId
        storicoRecordsDeleted   
    }
}`;